import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { TAdaptedReferenceV3 } from '../../../../types/types';

@Component({
    selector: 'app-new-source-preview-button',
    templateUrl: './new-source-preview-button.component.html',
    styleUrls: ['./new-source-preview-button.component.scss'],
    standalone: true,
    imports: [MatIcon],
})
export class NewSourcePreviewButtonComponent {
  @Input() adaptedReference: TAdaptedReferenceV3 | null = null;
  @Input() displayLabelOverride: string | null = null;
  @Input() externalReferenceIndex: number | null = null;
  @Input() iconOnly = false;
  @Output() buttonClicked = new EventEmitter<TAdaptedReferenceV3>();

  protected displayLabel(): string | null {
    if (this.iconOnly) {
      return null;
    }
    if (this.displayLabelOverride?.trim()) {
      return this.displayLabelOverride.trim();
    }
    const ref = this.adaptedReference;
    if (!ref) {
      return null;
    }
    if (ref.uiDisplayLabel?.trim()) {
      return ref.uiDisplayLabel.trim();
    }
    return ref.listPositionIndex != null ? String(ref.listPositionIndex) : null;
  }

  protected ariaLabel(): string {
    const label = this.displayLabel();
    if (label) {
      return `Reference ${label}`;
    }
    if (this.iconOnly) {
      return 'Open source';
    }
    if (!this.adaptedReference) {
      return 'Open source';
    }
    return 'View full source';
  }

  buttonClickedHandler(event: MouseEvent) {
    event.stopPropagation();
    if (!this.adaptedReference) {
      return;
    }
    this.buttonClicked.emit({
      ...this.adaptedReference,
      uiSelectedDisplayLabel: this.displayLabel() ?? undefined,
      uiSelectedExternalReferenceIndex: this.externalReferenceIndex,
    });
  }
}
